/**
 * Wait for selected children of given root to be rendered.
 * 
 * @param root 
 * @param selectors 
 */
export async function waitForElementsToLoad(
  root: Element | ShadowRoot,
  selectors: Array<string>
) {
  while (selectors.every((selector) => !root.querySelector(selector))) {
    await new Promise((r) => setTimeout(r, 500));
  }
}